export default [
  { title: 'DECOIT', to: 'https://decoit.de/home.html' },
  { title: 'AGB', to: '/Agb' },
  { title: 'Impressum', to: '/Impressum' },
  { title: 'Datenschutz', to: '/Datenschutz' },
];
